<template>
    <div id="addPix">
      <h2>Ajouter des photos</h2>           
      <div>
        <h3>
          <img src="data:image/svg+xml;base64,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" width="20" height="20">
          &nbsp;Déposer/Glisser vos photos (JPG seulement) dans le cadre ci-dessous ou <b>cliquer à l'intérieur</b> pour parcourir vos dossiers.
        </h3>
        <div class="borderUpload">
          <Upload-image is="upload-image" :url="contextPath" :max_files="40" name="files[]" :resize_enabled="true" :button_html="buttonText" :button_class="'button is-primary'" @allIsUploaded="allIsUploaded">            
          </Upload-image>
        </div>
      </div>      
    </div>
</template>

<script>
import UploadImage from '@/components/UploadImage.vue'
export default {
  name: 'addPix',  
  components: {
    UploadImage 
  },
  data() {         
    return {      
      buttonText: "Ajouter ces photos",
      contextPath: "backend/get/image/push"
    }    
  },
  mounted() {    
  },
  methods: {  
    allIsUploaded: function() {    
      //alert('All pictures are Uploaded !')
      this.$emit("checkUplOk")
    }  
  },
}
</script>

<style scoped>
#addPix {
    text-align:center;
    padding:10px;
    margin:10px;
    border:1px dashed #555;
    background-color:#aaa;
    border-radius: 4px;    
}

h2 {  
  background-size: 20px;
  padding-left: 25px;
  font-size: 1.1rem;
  font-weight: bold;  
}

h3 {
  font-size:16px;
  font-weight: normal;
}

p {
  margin-left:20px;
  margin-bottom:5px;
}
</style>